<template>
  <main>
    <div class="top-banner">
      <el-image class="institution-logo" :src="schoolInfo.logo" fit="cover" />
      <h1 @click="goSchool">
        <i class="el-icon-mic" />
        <span>{{ schoolInfo.live_title }}</span>
        <i class="el-icon-mic" />
      </h1>
    </div>
    <div class="container">
      <h2>{{ liveDetail.title }}</h2>
      <div class="broadcast-info">
        <div class="info-item">
          <label>直播时间: </label>
          <span>{{ liveDetail.live_time }}</span>
        </div>
        <div class="info-item">
          <label>主讲人: </label>
          <span>{{ liveDetail.teacher }}</span>
        </div>
      </div>
      <div class="viewers">
        <i class="el-icon-view" />
        <span>{{ liveDetail.view_count }}</span>
      </div>
      <div class="video-container">
        <iframe
          v-if="liveDetail.status == 1 && liveDetail.review_url"
          :src="liveDetail.review_url"
          frameborder="0"
          style="width: 100%; height: 100%"
        />
        <a v-else-if="liveDetail.status == 3" :href="liveDetail.live_url" class="view_box">
          <div class="play" />
          <el-image class="video-cover" :src="liveDetail.live_cover" />
        </a>
        <el-image v-else class="video-cover" :src="liveDetail.live_cover" />
      </div>
    </div>
    <div class="middle-banner">
      <span class="background-text">LIVE BROADCAST</span>
      <h3>直播介绍</h3>
    </div>
    <div class="broadcast-introduce">
      <div v-html="liveDetail.content" />
    </div>
    <div class="swiper-box">
      <i class="el-icon-arrow-left before-arrow" :disabled="step >= 0" @click="prePage()" />
      <div class="swiper-display">
        <ul ref="animationRef" class="experience-container">
          <li v-for="item in recommendLiveList" :key="item.id">
            <ListCard :card-data="item" />
          </li>
        </ul>
      </div>
      <i
        class="el-icon-arrow-right after-arrow"
        :disabled="step <= -(recommendLiveList.length - 3)"
        @click="nextPage()"
      />
    </div>
    <div class="bottom-banner">
      <span>版权所有&copy;{{ schoolInfo.name }} 斯奈特提供在线技术支持</span>
    </div>
  </main>
</template>

<script>
import ListCard from './components/ListCard'
import { getLiveDetail } from '@/api/customer'
export default {
  metaInfo() {
    return {
      title: this.title,
      meta: [
        {
          name: 'keywords',
          content: '',
        },
        {
          name: 'description',
          content: '',
        },
      ],
    }
  },
  components: {
    ListCard,
  },
  data() {
    return {
      hasVideo: true,
      step: 0,
      autoPlayTimer: null,
      introduce: '<p>嘿嘿嘿嘿</p>',
      schoolInfo: {},
      liveDetail: {},
      recommendLiveList: [],
    }
  },
  computed: {
    // 动态设置title
    title() {
      return this.schoolInfo.live_title || '招生直播宣讲会';
    }
  },
  watch: {
    recommendLiveList: {
      handler(val) {
        if (val.length > 0) {
          this.stepAutoPlay()
        }
      },
      deep: true,
    },
  },
  created() {
    this.loading = true
    getLiveDetail({ id: this.$route.params.id })
      .then((res) => {
        this.schoolInfo = res.data.school
        this.liveDetail = res.data.liveDetail
        this.recommendLiveList = res.data.recommendLiveList
        this.loading = false
      })
      .catch(() => {
        this.loading = false
        this.$message.error('请求详情发生错误')
      })
  },
  beforeDestroy() {
    clearInterval(this.autoPlayTimer)
  },
  methods: {
    stepAutoPlay() {
      this.autoPlayTimer = setInterval(() => {
        if (this.step <= -(this.recommendLiveList.length - 3)) {
          this.step = 0
        } else {
          this.step--
        }
        this.$refs.animationRef.style.transform = `translateX(${this.step * 402}px)`
      }, 3000)
    },
    prePage() {
      if (this.step >= 0) return
      clearInterval(this.autoPlayTimer)
      this.step++
      this.$refs.animationRef.style.transform = `translateX(${this.step * 402}px)`
      this.stepAutoPlay()
    },
    nextPage() {
      if (this.step <= -(this.recommendLiveList.length - 3)) return
      clearInterval(this.autoPlayTimer)
      this.step--
      this.$refs.animationRef.style.transform = `translateX(${this.step * 402}px)`
      this.stepAutoPlay()
    },
    goSchool() {
      this.$router.push({
        path: `/broadcast/list/${this.schoolInfo.id}`,
      })
    },
  },
}
</script>

<style lang="less" scoped>
main {
  width: 100%;

  .top-banner {
    width: 100%;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;
    background-image: linear-gradient(90deg, rgb(193, 193, 193),rgb(107, 107, 107)),linear-gradient(157.5deg, rgb(0, 165, 230) 0%, rgb(0, 165, 230) 39%,rgb(17, 149, 218) 39%, rgb(17, 149, 218) 56%,rgb(35, 132, 206) 56%, rgb(35, 132, 206) 60%,rgb(52, 116, 195) 60%, rgb(52, 116, 195) 68%,rgb(70, 99, 183) 68%, rgb(70, 99, 183) 86%,rgb(87, 83, 171) 86%, rgb(87, 83, 171) 100%),linear-gradient(135deg, rgb(0, 165, 230) 0%, rgb(0, 165, 230) 39%,rgb(17, 149, 218) 39%, rgb(17, 149, 218) 56%,rgb(35, 132, 206) 56%, rgb(35, 132, 206) 60%,rgb(52, 116, 195) 60%, rgb(52, 116, 195) 68%,rgb(70, 99, 183) 68%, rgb(70, 99, 183) 86%,rgb(87, 83, 171) 86%, rgb(87, 83, 171) 100%); background-blend-mode:overlay,overlay,normal;

    .institution-logo {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
    }

    h1 {
      color: #ffffff;
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
    }
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    z-index: 1;

    h2 {
      margin-top: 80px;
      font-size: 30px;
      text-align: center;
    }

    .broadcast-info {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      font-size: 20px;
      color: #979797;
    }

    .viewers {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 20px;
      font-size: 18px;
      color: #979797;
      margin-bottom: 40px;
    }

    .video-container {
      width: 100%;
      height: 680px;

      .video-cover {
        width: 100%;
        background-color: #000;
      }
      .video-player {
        width: 100%;
      }
      .view_box {
        position: relative;
        .play {
          position: absolute;
          transform: translate(-50%, -50%);
          top: 50%;
          left: 50%;
          background: url('/robots/images/icons/play.png') no-repeat;
          width: 120px;
          height: 120px;
          background-size: 120px 120px;
          z-index: 99;
        }
      }
    }
  }

  .middle-banner {
    margin-top: -150px;
    width: 100%;
    height: 300px;
    padding-bottom: 48px;
    background: linear-gradient(to bottom, #2a85f2, #1051da);
    z-index: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    .background-text {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translate(-50%) scaleY(0.8);
      color: #ffffff11;
      font-size: 140px;
      font-weight: bolder;
      letter-spacing: 8px;
      white-space: nowrap;
    }

    h3 {
      font-size: 32px;
      color: #ffffff;
    }
  }

  .broadcast-introduce {
    width: 1200px;
    margin: 60px auto;
    ::v-deep {
      img {
        max-width: 100%;
      }
      p {
        line-height: 2;
        color: #333333;
        margin-bottom: 12px;

        strong {
          color: #a661e8;
        }
      }
      a {
        display: inline;
        color: #5d159d;
      }
      a:hover {
        color: #cb2626;
      }
      table {
        border-collapse: collapse;
        box-sizing: border-box;
        outline: none;
        tbody {
          tr th {
            background-color: #f2f4f7;
            font-weight: 600;
            text-align: center;
            border: 1px solid #dedede;
            padding: 3px 5px;
          }
          tr td {
            border: 1px solid #dedede;
            line-height: 1.5;
            min-width: 30px;
            height: 30px;
            padding: 3px 5px;
            text-align: left;
            display: table-cell;
          }
        }
      }
      ol {
        list-style: decimal inside;
      }
      ul {
        list-style: disc inside;
      }
    }
  }

  .swiper-box {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    &:hover ul {
      animation-play-state: paused;
    }

    i.before-arrow {
      left: -60px;
    }
    i.after-arrow {
      right: -60px;
    }

    i.before-arrow,
    i.after-arrow {
      color: #2b5bf4cc;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 40px;
      cursor: pointer;
      position: absolute;
      z-index: 9;

      &:hover,
      &:active {
        color: #2b5bf4;
      }

      &[disabled='disabled'] {
        opacity: 0.5;
        &:hover {
          color: #2b5bf4cc;
        }
      }
    }

    .swiper-display {
      flex: 1;
      overflow: hidden;
      margin-bottom: 60px;
      // height: 360px;

      ul {
        list-style: none;
        // height: 360px;
        white-space: nowrap;
        transition: all 0.5s;

        li {
          list-style: none;
          display: inline-block;
          margin: 0 8px;
          width: 386px;
          // height: 360px;
          overflow: hidden;
          cursor: pointer;

          &:first-child {
            margin-left: 0;
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }

  .bottom-banner {
    width: 100%;
    height: 120px;
    border-top: 20px solid #66d5c8;
    background: linear-gradient(to bottom, #4b71ff, #2b5bf4);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 20px;
    font-weight: bold;
  }
}
</style>
